export const ROUTES = [
  { id: 'home', label: 'Home', icon: 'home' },
  { id: 'jobs', label: 'Jobs', icon: 'jobs' },
  { id: 'crimes', label: 'Crimes', icon: 'crimes' },
  // The Ward sits directly under Crimes because that is where a player arrives from: a bust is
  // the only thing that puts anybody in it, and GAME-DESIGN:1780 engineers the first one during
  // onboarding.
  { id: 'ward', label: 'The Ward', icon: 'lock' },
  { id: 'families', label: 'Families', icon: 'families' },
  { id: 'market', label: 'Market', icon: 'market' },
  { id: 'territory', label: 'Territory', icon: 'territory' },
  // The War Room sits directly under Territory because that is the only place a player arrives
  // from: it is the board for one contested block, and the map is where a block is chosen.
  { id: 'warroom', label: 'War Room', icon: 'target' },
  { id: 'contracts', label: 'Contracts', icon: 'contracts' },
  // The Street sits directly above the Hitlist because that is the order a player uses them in:
  // you find somebody on the Fight List, and the board is where you pay somebody else to do it.
  // Both were unreachable until Phase 8, and the Hitlist rendered its authored roster with no
  // server behind it at all.
  { id: 'fights', label: 'The Street', icon: 'target' },
  { id: 'hitlist', label: 'Hitlist', icon: 'hitlist' },
  { id: 'scanner', label: 'Scanner', icon: 'scanner' },
  { id: 'ledger', label: 'Ledger', icon: 'ledger' },
] as const

export type Route = (typeof ROUTES)[number]['id']
